if (!customElements.get('tabbed-products')) {
  class TabbedProducts extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.updateActivePanel.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
      });

      this.querySelectorAll('[data-tabbed-arrow]').forEach((button) => {
        button.addEventListener('click', () => this.scrollProducts(button));
      });

      this.querySelectorAll('[data-tabbed-track]').forEach((track) => {
        track.addEventListener('scroll', () => this.updateArrows(track), { passive: true });
      });

      this.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find((item) => item.dataset.blockId === event.detail.blockId);
        if (tab) this.selectTab(tab);
      });

      window.addEventListener('resize', this.handleResize);
      this.updateActivePanel();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    selectTab(tab, moveFocus = false) {
      const panelId = tab.getAttribute('aria-controls');

      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      if (moveFocus) tab.focus();
      this.updateActivePanel();
    }

    handleTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      this.selectTab(this.tabs[nextIndex], true);
    }

    scrollProducts(button) {
      const panel = button.closest('[role="tabpanel"]');
      const track = panel && panel.querySelector('[data-tabbed-track]');
      const firstItem = track && track.querySelector('.tabbed-products__item');
      if (!track || !firstItem) return;

      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const direction = button.dataset.direction === 'next' ? 1 : -1;
      track.scrollBy({ left: direction * (firstItem.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    updateActivePanel() {
      const activePanel = this.panels && this.panels.find((panel) => !panel.hidden);
      const track = activePanel && activePanel.querySelector('[data-tabbed-track]');
      if (!activePanel || !track) return;

      const firstMedia = activePanel.querySelector('.tabbed-products__media');
      if (firstMedia) {
        activePanel.style.setProperty('--tabbed-products-media-height', `${firstMedia.getBoundingClientRect().height}px`);
      }

      this.updateArrows(track);
    }

    updateArrows(track) {
      const panel = track.closest('[role="tabpanel"]');
      const previous = panel && panel.querySelector('[data-direction="previous"]');
      const next = panel && panel.querySelector('[data-direction="next"]');
      if (!previous || !next) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2 || maxScroll <= 2;
    }
  }

  customElements.define('tabbed-products', TabbedProducts);
}
